/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityKeyAIcon24Solid = forwardRef('SecurityKeyAIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 19a7.003 7.003 0 0 0 6.71-5h2.79a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 21.5 9h-7.174A7 7 0 1 0 8 19Zm0-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" })));
});
